import type { CasinoGame } from '@ps/web-casino-types';
import { GADimension } from '@ps/web-core-enums';
// eslint-disable-next-line no-restricted-imports
import { getState } from '@ps/web-core-store';
import { customEvent } from '@ps/web-core-utils';
import { produce } from 'immer';
import { cloneDeep, get, set } from 'lodash';

import { TrackingCategory } from '../enums';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { gameDimensions } from './gameDimensions';
import { gameEntity } from './gameEntity';
import type { LaunchParams } from './types';

const gameEntities = (context: TrackingContextValue, game: CasinoGame, index?: number) =>
  produce(context, (draft) => {
    draft.entities = draft.entities || [];
    draft.entities.push(gameEntity(game, index));
  });

export const casinoGameLaunched = (
  context: TrackingContextValue,
  {
    game,
    index,
    totalGames = 1,
    buttonName = 'Play',
    playType,
    action = 'Game Launched'
  }: LaunchParams
) => {
  const widgetInfo = get(getState(), context?.widget?.widgetId || '');
  const realName = widgetInfo?.games?.title || context.widget?.widgetName;
  const newContext = set(cloneDeep(context), ['widget', 'widgetName'], realName);

  GAEvent(
    { action, label: game.name, value: game.gametype },
    { ...newContext, category: TrackingCategory.Casino },
    { [GADimension.GamePlayMode]: playType, ...gameDimensions(game, index, totalGames) }
  );

  customEvent({
    tag: 'WF_ClickToPlay',
    data: { widgetName: context.widget?.widgetName, ...game }
  });

  buttonClick({ buttonName }, gameEntities(context, game, index));
};
